export default "__VITE_ASSET__DW_$7jBW__"